import { FocusEvent, forwardRef, useState } from 'react'
import { IMaskInput } from 'react-imask'

interface Props {
  onChange: (event: { target: { name: string; value: string } }) => void
  onFocus: (e: FocusEvent) => void
  onBlur: (e: FocusEvent) => void
  name: string
  mask: string
  value: string
}

const AppInputMask = forwardRef<HTMLInputElement, Props>(
  ({ mask = '+{1} 000 000-0000', onChange, name, onFocus, onBlur, value, ...rest }, ref) => {
    const [isFocused, setIsFocused] = useState(false)
    const handleFocus = (e: FocusEvent) => {
      setIsFocused(true)
      onFocus(e)
    }
    const handleBlur = (e: FocusEvent) => {
      if (value === '+1 ___ ___-____') {
        setIsFocused(false)
      }

      onBlur(e)
    }

    return (
      <IMaskInput
        overwrite
        lazy={!isFocused}
        type="tel"
        mask={mask}
        inputRef={ref}
        onAccept={(value: string) => {
          onChange({ target: { name, value } })
        }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        {...rest}
      />
    )
  },
)

export default AppInputMask
